/* Bundle builder 2+1 — krokový wizard. Dedí DrawerElement (overlay, swipe, lock).
   Kroky: 3 páry (model z horizontálneho scrollera + veľkosť), potom sumár. Najlacnejší pár zadarmo. */
customElements.whenDefined('drawer-element').then(() => {
  const Drawer = customElements.get('drawer-element');

  const money = (cents) => {
    try { return theme.Currency.formatMoney(cents, theme.settings.moneyFormat); }
    catch (e) { return (cents / 100).toFixed(2); }
  };

  const el = (tag, className, attrs) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (attrs) Object.keys(attrs).forEach((k) => node.setAttribute(k, attrs[k]));
    return node;
  };

  class BundleBuilder extends Drawer {
    connectedCallback() {
      super.connectedCallback();
      if (this._built) return;
      this._built = true;

      this.S = window.bundleStrings || {};
      this.products = this.readProducts();
      this.count = parseInt(this.getAttribute('data-slot-count'), 10) || 3;
      this.currentHandle = this.getAttribute('data-current-handle');
      this.currentVariant = this.getAttribute('data-current-variant');

      this.stepsEl = this.querySelector('[data-bundle-steps]');
      this.stageEl = this.querySelector('[data-bundle-stage]');
      this.footerEl = this.querySelector('[data-bundle-footer]');

      this.modelByStep = new Array(this.count).fill(null);
      this.selections = new Array(this.count).fill(null);
      this.step = 0;

      if (!this.products.length || !this.stageEl) return;

      this.prefill();
      this.render();
    }

    readProducts() {
      const tag = this.querySelector('[data-bundle-products]') || document.querySelector('[data-bundle-products]');
      if (!tag) return [];
      try { return JSON.parse(tag.textContent); } catch (e) { return []; }
    }

    productByHandle(h) { return this.products.find((p) => p.handle === h); }

    prefill() {
      const p = this.productByHandle(this.currentHandle);
      if (!p) return;
      this.modelByStep[0] = p.handle;
      const v = p.variants.find((x) => String(x.id) === String(this.currentVariant) && x.available);
      if (v) this.selections[0] = this.toSelection(p, v);
    }

    toSelection(product, variant) {
      return { handle: product.handle, title: product.title, variantId: variant.id, size: variant.title, price: variant.price, priceHtml: variant.price_html };
    }

    /* ---------- render ---------- */
    render() {
      this.renderSteps();
      if (this.step < this.count) this.renderPairStep(this.step);
      else this.renderSummary();
      this.renderFooter();
    }

    renderSteps() {
      this.stepsEl.innerHTML = '';
      const wrap = el('div', 'bundle-steps');
      for (let i = 0; i < this.count; i++) {
        const dot = el('span', 'bundle-steps__dot');
        if (i === this.step) dot.classList.add('is-current');
        if (this.selections[i]) dot.classList.add('is-done');
        dot.textContent = this.selections[i] && i !== this.step ? '✓' : (i + 1);
        wrap.appendChild(dot);
        if (i < this.count) {
          const line = el('span', 'bundle-steps__line');
          wrap.appendChild(line);
        }
      }
      const sum = el('span', 'bundle-steps__dot');
      if (this.step === this.count) sum.classList.add('is-current');
      sum.innerHTML = '<i class="bundle-ico-check" aria-hidden="true">✓</i>';
      wrap.appendChild(sum);
      this.stepsEl.appendChild(wrap);
    }

    renderPairStep(i) {
      this.stageEl.innerHTML = '';
      const head = el('p', 'bundle-stage__title');
      head.textContent = (this.S.pairLabel || '%n%').replace('%n%', i + 1) + ' — ' + (this.S.chooseModel || '');
      this.stageEl.appendChild(head);

      const scroller = el('div', 'bundle-scroller');
      this.products.forEach((p) => scroller.appendChild(this.buildCard(i, p)));
      this.stageEl.appendChild(scroller);
        const selCard = scroller.querySelector('.bundle-card.is-selected');
        if (selCard) {
          const target = selCard.offsetLeft - scroller.offsetLeft - (scroller.clientWidth - selCard.offsetWidth) / 2;
          scroller.scrollLeft = Math.max(0, target);
        }

      const activeHandle = this.modelByStep[i];
      if (activeHandle) {
        this.stageEl.appendChild(this.buildSizeArea(i, this.productByHandle(activeHandle)));
      }
    }

    buildCard(i, product) {
      const selected = this.modelByStep[i] === product.handle;
      const card = el('button', 'bundle-card' + (selected ? ' is-selected' : ''), { type: 'button' });
      card.dataset.handle = product.handle;

      const media = el('span', 'bundle-card__media');
      if (product.image) {
        const img = el('img');
        img.src = product.image; img.alt = product.title; img.loading = 'lazy';
        img.width = 160; img.height = 160;
        media.appendChild(img);
      }
      const mark = el('span', 'bundle-card__mark');
      mark.innerHTML = selected ? '✓' : '+';
      media.appendChild(mark);

      const body = el('span', 'bundle-card__body');
      const name = el('span', 'bundle-card__name');
      name.textContent = product.title;
      const desc = el('span', 'bundle-card__desc');
      desc.textContent = product.indication || '';
      const price = el('span', 'bundle-card__price');
      price.innerHTML = product.variants[0] ? product.variants[0].price_html : '';
      body.append(name, desc, price);

      card.append(media, body);
      card.addEventListener('click', () => this.selectModel(i, product.handle));
      return card;
    }

    buildSizeArea(i, product) {
      const area = el('div', 'bundle-size');
      const label = el('p', 'bundle-size__label');
      label.textContent = (this.S.chooseSize || '') + ' · ' + product.title;
      area.appendChild(label);

      const chips = el('div', 'bundle-size__chips');
      const chosen = this.selections[i];
      product.variants.forEach((v) => {
        const chip = el('button', 'bundle-chip', { type: 'button' });
        if (!v.available) { chip.classList.add('is-disabled'); chip.disabled = true; }
        if (chosen && chosen.variantId === v.id) chip.classList.add('is-active');
        chip.textContent = v.title;
        chip.addEventListener('click', () => this.selectSize(i, product, v));
        chips.appendChild(chip);
      });
      area.appendChild(chips);
      if (this.S.sizeNote) {
        const note = el('p', 'bundle-size__note');
        note.textContent = this.S.sizeNote;
        area.appendChild(note);
      }
      const tpl = this.querySelector('[data-bundle-sizechart]') || document.querySelector('[data-bundle-sizechart]');
      if (tpl) {
        const chart = el('button', 'bundle-size__chart', { type: 'button' });
        chart.textContent = this.S.sizeChartLabel || 'Größentabelle';
        const panel = el('div', 'bundle-sizechart__panel');
        panel.hidden = true;
        panel.appendChild(tpl.content.cloneNode(true));
        chart.addEventListener('click', () => { panel.hidden = !panel.hidden; chart.classList.toggle('is-open', !panel.hidden); });
        area.appendChild(chart);
        area.appendChild(panel);
      }
      return area;
    }

    renderSummary() {
      this.stageEl.innerHTML = '';
      const head = el('p', 'bundle-stage__title');
      head.textContent = this.S.summary || '';
      this.stageEl.appendChild(head);

      const freeIdx = this.cheapestIndex();
      const list = el('div', 'bundle-summary');
      this.selections.forEach((s, i) => {
        const row = el('div', 'bundle-summary__row' + (i === freeIdx ? ' is-free' : ''));
        const left = el('span', 'bundle-summary__name');
        left.textContent = s.title + ' · ' + s.size;
        const right = el('span', 'bundle-summary__price');
        if (i === freeIdx) {
          right.innerHTML = '<s>' + s.priceHtml + '</s><span class="bundle-free-badge">' + (this.S.freeBadge || '') + '</span>';
        } else {
          right.innerHTML = s.priceHtml;
        }
        row.append(left, right);
        list.appendChild(row);
      });
      this.stageEl.appendChild(list);
    }

    /* ---------- footer ---------- */
    renderFooter() {
      this.footerEl.innerHTML = '';
      if (this.step < this.count) {
        const nav = el('div', 'bundle-footer__nav');
        if (this.step > 0) nav.appendChild(this.navButton(this.S.back || '', () => this.go(this.step - 1), 'secondary'));
        const cont = this.navButton(this.S.continue || '', () => this.go(this.step + 1), 'primary');
        cont.disabled = !this.selections[this.step];
        nav.appendChild(cont);
        this.footerEl.appendChild(nav);
      } else {
        const sum = el('div', 'bundle-footer__summary');
        const freeIdx = this.cheapestIndex();
        const total = this.selections.reduce((a, s) => a + s.price, 0) - (freeIdx > -1 ? this.selections[freeIdx].price : 0);
        const free = freeIdx > -1 ? this.selections[freeIdx].price : 0;
        const tot = el('span', 'text-sm');
        tot.innerHTML = (this.S.total || '') + ' <strong>' + money(total) + '</strong>';
        const sav = el('span', 'bundle-builder__savings text-xs font-medium');
        sav.textContent = (this.S.savings || '%a%').replace('%a%', money(free));
        sum.append(tot, sav);
        this.footerEl.appendChild(sum);

        this.addBtn = this.navButton(this.S.addToCart || '', () => this.addToCart(), 'primary');
        this.addBtn.classList.add('w-full');
        this.footerEl.appendChild(this.addBtn);

        const over = el('button', 'bundle-startover', { type: 'button' });
        over.textContent = this.S.startOver || '';
        over.addEventListener('click', () => this.startOver());
        this.footerEl.appendChild(over);
      }
    }

    navButton(label, onClick, variant) {
      const btn = document.createElement('button', { is: 'hover-button' });
      btn.setAttribute('is', 'hover-button');
      btn.type = 'button';
      btn.className = 'button button--' + (variant || 'primary');
      const fill = el('span', 'btn-fill'); fill.setAttribute('data-fill', '');
      const text = el('span', 'btn-text'); text.textContent = label;
      btn.append(fill, text);
      btn.addEventListener('click', onClick);
      return btn;
    }

    /* ---------- actions ---------- */
    selectModel(i, handle) {
      if (this.modelByStep[i] !== handle && this.selections[i] && this.selections[i].handle !== handle) {
        this.selections[i] = null;
      }
      this.modelByStep[i] = handle;
      const product = this.productByHandle(handle);
      const available = product.variants.filter((v) => v.available);
      if (available.length === 1 && !this.selections[i]) {
        this.selections[i] = this.toSelection(product, available[0]);
      }
      this.render();
    }

    selectSize(i, product, variant) {
      this.selections[i] = this.toSelection(product, variant);
      this.render();
    }

    go(step) {
      this.step = Math.max(0, Math.min(this.count, step));
      this.render();
      this.stageEl.scrollTop = 0;
    }

    startOver() {
      this.modelByStep = new Array(this.count).fill(null);
      this.selections = new Array(this.count).fill(null);
      this.step = 0;
      this.prefill();
      this.render();
    }

    cheapestIndex() {
      let idx = -1; let min = Infinity;
      this.selections.forEach((s, i) => { if (s && s.price < min) { min = s.price; idx = i; } });
      return idx;
    }

    async addToCart() {
      if (!this.selections.every(Boolean) || this._busy) return;
      this._busy = true;
      this.addBtn.setAttribute('aria-busy', 'true');
      const btnText = this.addBtn.querySelector('.btn-text');
      if (btnText) btnText.textContent = this.S.adding || '';

      const items = this.selections.map((s) => ({ id: s.variantId, quantity: 1, properties: { _bundle: '2+1' } }));
      let sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));

      try {
        const config = theme.utils.fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({ items, sections, sections_url: window.location.pathname });

        const parsed = await (await fetch(theme.routes.cart_add_url, config)).json();
        if (parsed.status) { if (btnText) btnText.textContent = this.S.error || ''; return; }

        const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
        cartJson.sections = parsed.sections;
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-builder', cart: cartJson });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: parsed } }));

        this.hide();
        document.querySelector('cart-drawer')?.show();
      } catch (e) {
        if (btnText) btnText.textContent = this.S.error || '';
      } finally {
        this._busy = false;
        this.addBtn.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('bundle-builder')) {
    customElements.define('bundle-builder', BundleBuilder);
  }
});
